// extracted by mini-css-extract-plugin
export default {"section":"ProjectsSection_section__JfsQ+","columns":"ProjectsSection_columns__vojDo","fadeUp":"ProjectsSection_fadeUp__h172X"};